import React, { useState, useEffect } from "react";
import { Sidebar } from "primereact/sidebar";
import SidebarContent from "./SidebarContent";
import apiService from "../../services/service";
import "./sidebar.scss";
import EmptyHistory from "./EmptyHistory";
import SuccessNotification from "../entities/address/SuccessNotification";
import z from "zod";
import InfiniteScroll from "react-infinite-scroll-component";

const AuditSidebar = ({
  heading,
  sidebarToggle,
  setSidebarToggle,
  endpoint,
  id,
  labels,
  nameLink = "",
  objectType = "",
  endType = "",
  overrideName = "",
  tab = null,
  entityId = null,
}) => {
  const [data, setData] = useState([]);
  const [isDataFetching, setDataFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);

  const handleFetchSidebarData = async () => {
    if (loading || !hasMoreData) return;
    setDataFetching(true);
    setLoading(true);
    const replaceParams = { id, page, objectType, tab };
    if (entityId) {
      replaceParams.entityId = entityId;
    }
    const response = await apiService(endpoint, "GET", {
      skipCache: true,
      replace: replaceParams,
      schema: z.object({
        id: z.string().uuid().optional(),
        page: z.number().min(1),
      }),
    });
    await setDataFetching(false);
    // Handle both response formats: response.data (array) or response.data.data (nested)
    const auditData = Array.isArray(response?.data)
      ? response.data
      : response?.data?.data;
    // DEBUG: Log the raw API response to check timestamps
    console.log("AuditSidebar raw API response:", response?.data);
    console.log(
      "AuditSidebar auditData timestamps:",
      auditData?.map((item) => ({ id: item.id, timestamp: item.timestamp })),
    );
    if (auditData?.length) {
      setData((prev) => [...prev, ...auditData]);
      setPage((prev) => prev + 1);
    } else {
      setHasMoreData(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    handleFetchSidebarData();
  }, []);

  const customHeader = (
    <div className="sidebar-header flex align-items-center gap-1">
      <span className="pi pi-history history-icon" />
      <h3 className=" m-0">{heading ? `History: ${heading}` : "History"}</h3>
    </div>
  );

  return (
    <div className="sidebar-main card flex justify-content-center">
      <Sidebar
        position="right"
        className="history__sidebar"
        header={customHeader}
        visible={sidebarToggle}
        onHide={() => setSidebarToggle(false)}
      >
        {data?.length || isDataFetching ? (
          <div id="audit-sidebar-scroll">
            <InfiniteScroll
              dataLength={data.length}
              next={handleFetchSidebarData}
              hasMore={hasMoreData}
              loader={
                data?.length && isDataFetching ? (
                  <p>Loading more data...</p>
                ) : null
              }
              endMessage={<SuccessNotification successMsg="All data loaded" />}
              scrollableTarget="audit-sidebar-scroll"
            >
              <SidebarContent
                data={data}
                labels={labels}
                nameLink={nameLink}
                endType={endType}
                overrideName={overrideName}
                objectType={objectType}
              />
            </InfiniteScroll>
          </div>
        ) : (
          <EmptyHistory />
        )}
      </Sidebar>
    </div>
  );
};

export default AuditSidebar;
